import BaseApi from "./base";

class BeneficiariosControladoresApi extends BaseApi {
  constructor() {
    super("beneficiarios-controladores");
  }

  getBeneficiariosControladoresByAccionistaComparecienteId(accionistaComparecienteId) {
    return this.request.get(`/beneficiarios-controladores/by-accionista-compareciente/${accionistaComparecienteId}`);
  }
}

export default new BeneficiariosControladoresApi();
